export default {"src":"/_next/static/media/antad.949cb965.svg","height":141,"width":235};